import { Coordinate } from '@models/coordinate';
import proj from 'ol/proj';

function fromProjection(coordinate: Coordinate): string {
  return /^epsg:/i.test(coordinate.epsg) ? coordinate.epsg.toUpperCase() : 'EPSG:' + coordinate.epsg;
}

export function transformOL(position: ol.Coordinate, fromProj: any, toProjection: any): ol.Coordinate {
  const from = proj.get(fromProj);
  if (!from) {
    console.error('unknown projection: ', fromProj);
    return;
  }

  const to = proj.get(toProjection);
  if (!to) {
    console.error('unknown projection: ', toProjection);
    return;
  }

  return proj.transform(position, from as any, to as any);
}

export function transform(coordinate: Coordinate, epsg: string): Coordinate {
  const fromProj: any = fromProjection(coordinate);
  const toProj: any = epsg;
  const pos = [coordinate.x, coordinate.y];
  const newPos = transformOL(pos as ol.Coordinate, fromProj, toProj);
  if (newPos) {
    return {
      x: newPos[0],
      y: newPos[1],
      epsg: epsg
    };
  }
}

export function coordToPosition(coordinate: Coordinate): ol.Coordinate {
  const fromProj: any = fromProjection(coordinate);
  const toProj: any = 'EPSG:4326';
  const from = proj.get(fromProj);
  const to = proj.get(toProj);

  if (!from) {
    console.error('unknown projection: ', fromProj);
    return;
  }

  if (!to) {
    console.error('unknown projection: ', toProj);
    return;
  }

  let pos = [coordinate.x, coordinate.y];
  return proj.transform(<ol.Coordinate>pos, <any>from, <any>to);
}
